// extracted by mini-css-extract-plugin
module.exports = {"container":"settlement_container__2aX_v"};